import { PropsWithChildren } from 'react';

import { CacheProvider, type EmotionCache } from '@emotion/react';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';

import defaultTheme from './theme';

export type UIThemeProviderProps = Record<string, unknown> & {
  emotionCache: EmotionCache;
};

export default function UIThemeProvider({
  emotionCache,
  children,
}: PropsWithChildren<UIThemeProviderProps>): React.ReactElement {
  return (
    <CacheProvider value={emotionCache}>
      <ThemeProvider theme={defaultTheme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </CacheProvider>
  );
}
